<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>User Profile</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div
    sxMaxWidth="500px"
    sxMargin="0 auto"
    sxPadding="medium"
    sxCol
    sxGap="10px"
    *ngIf="user$ | async as user">
    <div class="center full-width padding-heavy">
      <avatar-round
        [size]="120"
        [isEditMode]="true"
        [imageUrl]="user?.displayPictureUrl"
        [autoBase]="true"
        [title]="user?.name"
        [onImageAction]="uploadUserDisplayPic"
      ></avatar-round>
    </div>
    <h3 sxMargin="10px 0 0 20px">Your Details</h3>
      <ion-list sxCursor="pointer">
        <ion-item (click)="saveUser('name')">
          <ion-label>Name</ion-label>
          <ion-text slot="end">{{
              user?.name
            }}
          </ion-text>
        </ion-item>
        <ion-item (click)="updateEmail()">
          <ion-label>Email</ion-label>
          <ion-text slot="end">{{
              user?.email
            }}
          </ion-text>
        </ion-item>
        <ion-item (click)="updateMobile()">
          <ion-label>Phone</ion-label>
          <ion-text slot="end">{{
              user?.phoneNumber | formatPhone
            }}
          </ion-text>
        </ion-item>
      </ion-list>
    </div>
</ion-content>
